import _implicitStylesheets from "./link.css";
import _implicitScopedStylesheets from "./link.scoped.css?scoped=true";
import _wdsAnalyticsInstrument from "wds/analyticsInstrument";
import _i18nLink from "i18n/link";
import {freezeTemplate, registerTemplate} from "lwc";
const stc0 = {
  "type": "link"
};
const stc1 = {
  key: 1
};
const stc2 = [];
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, s: api_slot, c: api_custom_element} = $api;
  const {_m0, _m1} = $ctx;
  return [!$cmp.i18nMessage ? api_custom_element("wds-analytics-instrument", _wdsAnalyticsInstrument, {
    props: stc0,
    key: 0,
    on: {
      "analytics": _m0 || ($ctx._m0 = api_bind($cmp.handleAnalytics))
    }
  }, [api_slot("", stc1, stc2, $slotset)]) : null, $cmp.i18nMessage ? api_custom_element("i18n-link", _i18nLink, {
    props: {
      "message": $cmp.i18nMessage,
      "ariaLabel": $cmp.customAriaLabel,
      "target": $cmp.target,
      "customEventGenerator": $cmp.customEventGenerator
    },
    key: 2,
    on: {
      "anchor_clicked": _m1 || ($ctx._m1 = api_bind($cmp.handleI18nLinkClicked))
    }
  }) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.slots = [""];
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-1pr1mcdqssh";
tmpl.legacyStylesheetToken = "undefined-_link";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
